import { render, staticRenderFns } from "./AdminPopupCreated.vue?vue&type=template&id=4ceffe12&scoped=true&"
import script from "./AdminPopupCreated.vue?vue&type=script&lang=js&"
export * from "./AdminPopupCreated.vue?vue&type=script&lang=js&"
import style0 from "./AdminPopupCreated.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AdminPopupCreated.vue?vue&type=style&index=1&id=4ceffe12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceffe12",
  null
  
)

export default component.exports